import React from "react";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import i18next from "../../i18n/i18n";

export function FileAttachmentButton({
    inputRef,
    onFileInputChange,
    disabled,
    acceptedFileTypes
}: {
    inputRef: React.RefObject<HTMLInputElement | null>;
    onFileInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    disabled?: boolean;
    acceptedFileTypes: string[];
}) {
    return (
        <>
            <button
                type="button"
                aria-label={i18next.t("chat.attachFile")}
                onClick={() => inputRef.current?.click()}
                disabled={disabled}
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background: "none",
                    border: "none",
                    padding: 8,
                    cursor: disabled ? "not-allowed" : "pointer",
                    marginRight: 0,
                    color: disabled ? "#aaa" : "#6a6ee6",
                    borderRadius: "50%",
                    outline: "none"
                }}
                tabIndex={0}
            >
                <AttachFileIcon
                    fontSize="medium"
                    sx={{
                        color: disabled ? "#aaa" : "#6a6ee6",
                        backgroundColor: "transparent"
                    }}
                />
            </button>
            <input
                ref={inputRef}
                type="file"
                accept={acceptedFileTypes.join(",")}
                multiple
                style={{ display: "none" }}
                disabled={disabled}
                onChange={onFileInputChange}
            />
        </>
    );
}
